import * as React from 'react'
import PropTypes from 'prop-types'
import { useState, useEffect } from 'react';
import "./Styles/Counter.css"
import "./Styles/LetterWelcome.css"
import axios from 'axios';


export const BannerPromotional = ({closeBannerMain, ap, deviceId, passPortal, test}) => {

    const [banner, setBanner] = useState(null);

    let interval = null;
    const [counter, setCounter] = useState<number>(5);
    let counterLocal = counter;


    useEffect(() => {
        //initCounter();
        getBannerMain();
        return () => {
            if(interval) {
                clearInterval(interval);    
            }
        };
    }, [ap]);
    

    const getBannerMain = async () => {
        try {
            if(ap) {
                const resp = await axios.get("/bannermain", {
                    params: {
                        location: ap.ap_locationid,
                        deviceId: !test ? deviceId : '' ,
                        ap_mac: ap.ap_mac
                    }
                }); 
                const banner = resp.data;
                if(banner.ok && banner.banners.active) {
                    setBanner(banner.banners);
                    setCounter(banner.banners.skip_seconds)
                    initCounter(banner.banners);
                } else {
                    closeBannerMain(true);
                }
            } 
        } catch (error) {
            console.error(error);
            closeBannerMain(true);

        }
    }

    const initCounter = (banner) => {
        counterLocal = banner.skip_seconds;
        interval = setInterval(() => {
            counterLocal = counterLocal - 1;
            
            setCounter(counterLocal);
            if(counterLocal == 0) {
                clearInterval(interval);
                if(banner.skip_all) {
                    passPortal(ap,{ CampaignID: 0, RedirectURL: banner.redirect_url}, deviceId);
                } else {
                    closeBannerMain(true);
                }
            }
        }, 1000);
    }

    return (
        <div style={{
            position: 'relative',
            display: "flex",
            width: "700px",
            height: "100vh",
            zIndex: 100
        }}>
            {
                (banner && banner.active) ? (
                    <>
                    <div className="col-md-3 col-sm-6 p-2">
                    <div className="counter" style={{
                        position: "absolute",
                        right: 1,
                        padding: "10px"
                    }}>
                        <span className="counter-value" style={{width: "60px", height: "60px", fontSize: "36px", color: "#000000"}}>{counter}</span>
                    </div>
                    </div>
                    <img
                        style={{
                            width: "100%",
                            height: "100vh",
                            position: "absolute",
                        }}
                        src={`/google-storage/${encodeURIComponent(banner.src)}`}
                        />
                    {
                        (banner.welcome_label_default) && (
                            <div className="container_letter">
                                <div className="sub_container" style={{
                                    backgroundColor: banner.backgroundColor ? banner.backgroundColor : "rgb(185, 71, 71)"
                                }}>
                                    <h3 className="letter">{banner.welcome_label_default.toUpperCase()}</h3>
                                    <h5 className="letter">{banner.storeNanme.toUpperCase()}</h5>
                                </div>
                            </div>
                        )
                    }
                    </>
                    
                ) : <></>
            }
            
        </div>
    )
}

